<script>
    /**
     * 按钮
     */
    export default {
        name: 'normal-switch',
        props: {
            text: {
                type: String,
                default: '',
                required: false
            },
            theme: {
                default: 'grey',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            checked: {
                // type: Boolean,
                default: false,
                required: false
            }
        },
        model: {
            prop: 'checked',
            event: 'change'
        },
        computed: {
            sclass () {
                if (this.disabled) {
                    return 'switch-disabled';
                } else if (this.ischecked) {
                    return 'switch-checked';
                } else {
                    return '';
                }
            }
        },
        watch: {
            disabled (v) {
                if (v) {
                    // this.ischecked = false;
                }
            },
            checked (v) {
                this.ischecked = v;
            }
        },
        methods: {
            onClick () {
                if (this.disabled) {
                    return;
                }
                this.ischecked = !this.ischecked;
                this.$emit('change', this.ischecked);
            }
        },
        data () {
            return {
                ischecked: this.checked
            };
        }
    };
</script>

<template>
    <div class="switch-box" :class="[theme]">
        <span v-if="text" class="switch-text">{{text}}</span>
        <span class="switch" @click="onClick($event)" :class="[{'switch-disabled':disabled,'switch-checked':ischecked}]">
            <span class="switch-inner"></span>
        </span>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    @switch-duration: .36s;
    @switch-duration-short: .16s;

    .switch-box {
        box-sizing: border-box;
        height: @widgetsHeight;
        line-height: @widgetsHeight;
        float: left;
    }

    .switch-text {
        font-size: 14px;
        line-height: 22px;
        vertical-align: middle;
    }

    .switch {
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        height: 26px;
        min-width: 48px;
        line-height: 20px;
        vertical-align: middle;
        border-radius: 20px;
        border: 1px solid transparent;
        background-color: @otherGreyBgClr;
        cursor: pointer;
        transition: all @switch-duration;
        user-select: none;

        &-inner {
            color: #fff;
            font-size: 12px;
            margin-left: 24px;
            margin-right: 6px;
            display: block;
        }

        &:after {
            position: absolute;
            width: 22px;
            height: 22px;
            left: 1px;
            top: 1px;
            border-radius: 24px;
            background-color: #fff;
            content: "";
            font-size: 12px;
            text-align: center;
            line-height: 24px;
            color: @otherIptSelTipsDisbaledClr;
            font-family: cmsicon;
            cursor: pointer;
            transition: all @switch-duration ease-in-out;
            // -moz-animation: spin 2s infinite linear;
            // -o-animation: spin 2s infinite linear;
            // -webkit-animation: spin 2s infinite linear;
            // animation: spin 2s infinite linear;
        }

        &:active:after {
            width: 24px;
        }

        &:focus {
            box-shadow: 0 0 0 2px rgba(16, 142, 233, .2);
            outline: 0;
        }

        &:focus:hover {
            box-shadow: none;
        }

        &-checked {
            background-color: @primaryBg;

            .switch-inner {
                margin-left: 6px;
                margin-right: 24px;
            }

            &:after {
                left: 100%;
                margin-left: -23px;
            }

            &:active:after {
                margin-left: -23px;
            }
        }

        &-disabled {
            cursor: not-allowed;
            background: @otherIptSelTipsDisbaledClr;

            &:after {
                background:@whiteBg;
                cursor: not-allowed;
            }

            .switch-inner {
                color: @otherIptSelTipsDisbaledClr;
            }

            &.switch-checked{
                background-color: @primaryDisabledBg;
            }
        }
    }

    .switch-box.short {
        .switch {
            min-width: 30px;
            transition: all @switch-duration-short;

        }
    }

    .switch-box.slim {
        .switch {
            min-width: 36px;
            height: 18px;
            line-height: 18px;
            transition: all @switch-duration-short;

            &:after {
                width: 14px;
                height: 14px;
                line-height: 14px;
                border-radius: 14px;
            }

            &:active:after {
                width: 20px;
            }

            &-checked {
                .switch-inner {
                    margin-left: 6px;
                    margin-right: 24px;
                }

                &:after {
                    left: 100%;
                    margin-left: -15px;
                }

                &:active:after {
                    margin-left: -21px;
                }
            }
        }
    }

    .switch-box.warn {
        .switch {
            background-color: @dangerBg;

            &.switch-checked {
                background-color: @primaryBg;
            }
        }
    }
</style>
